module.exports = __webpack_public_path__ + "img/down.f2e7a1be.svg";